import { render, staticRenderFns } from "./iot-form-item.vue?vue&type=template&id=084d7c42&"
import script from "./iot-form-item.vue?vue&type=script&lang=js&"
export * from "./iot-form-item.vue?vue&type=script&lang=js&"
import style0 from "./iot-form-item.vue?vue&type=style&index=0&id=084d7c42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports